import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Service } from "utils/services";

interface AuthState {
  token: string | null;
  isAuthenticated: boolean;
  userAuth: any | null;
}

// const initialState: AuthState = {
//   token: localStorage.getItem("jwt") || null,
//   isAuthenticated: !!localStorage.getItem("jwt"),
//   userAuth: localStorage.getItem("user") || null,
// };

//* JK : I update with store user in service.
const initialState = (): AuthState => {
  const userJson = localStorage.getItem("user") || null;
  if (userJson) {
    Service.isAuthenticated = true;
    Service.userAuth = JSON.parse(userJson);
    Service.token = localStorage.getItem("jwt") || null;
    Service.authenticationKey = localStorage.getItem("authentication_key") || null;
  }

  return {
    token: Service.token,
    isAuthenticated: !!localStorage.getItem("jwt"),
    userAuth: Service.userAuth,
  };
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginSuccess(state, action: PayloadAction<string>) {
      state.token = action.payload;
      state.isAuthenticated = true;
      Service.isAuthenticated = true;
      localStorage.setItem("jwt", action.payload);
    },
    logout(state) {
      state.token = null;
      state.isAuthenticated = false;
      Service.isAuthenticated = false;
      localStorage.removeItem("jwt");
      localStorage.removeItem("user");
      localStorage.removeItem("authentication_key");

      // Don't use redirect in this logout function
    },
    updateAuthToken(state, action) {
      state.token = action.payload;
    },
  },
});

export const { loginSuccess, logout, updateAuthToken } = authSlice.actions; // Make sure logout is exported
export default authSlice.reducer;
